export const LeanAppOverviewDataHooks = {
  APP_NAME: 'lean-app-overview-app-name',
  CONTAINER: 'lean-app-overview-container',
  BENEFITS_LIST: 'lean-app-overview-benefits-list',
  LEARN_MORE_BUTTON: 'lean-app-overview-learn-more-button',
};
